// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"937e762a","453":"fc8cdae3","455":"99c3e81b","977":"08488ecc"}[chunkId] + ".chunk.js";
};